import { useEffect, useState } from "react";
import axios from "axios";
import { ChartLine, Users, Wallet } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

import { API } from "@/config";

const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    total_members: 0,
    total_passes_issued: 0,
    total_designs: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/stats`);
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      label: "Total Members",
      value: stats.total_members,
      icon: Users,
      color: "var(--brand)",
    },
    {
      label: "Passes Issued",
      value: stats.total_passes_issued,
      icon: Wallet,
      color: "#16A34A",
    },
    {
      label: "Pass Designs",
      value: stats.total_designs,
      icon: ChartLine,
      color: "#EAB308",
    },
  ];

  return (
    <div className="p-4 sm:p-6 lg:p-12" data-testid="dashboard">
      <div className="mb-8">
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900">
          Dashboard
        </h1>
        <p className="text-base text-zinc-600 mt-2">
          Overview of your club membership system
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div
              key={index}
              className="border border-zinc-200 bg-white p-6 rounded-md hover:shadow-md hover:-translate-y-1 transition-all"
              data-testid={`stat-card-${stat.label.toLowerCase().replace(" ", "-")}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div
                  className="w-12 h-12 rounded-md flex items-center justify-center"
                  style={{ backgroundColor: `${stat.color}15` }}
                >
                  <Icon size={24} color={stat.color} weight="regular" />
                </div>
              </div>
              <div className="text-3xl font-semibold text-zinc-900">
                {loading ? "—" : stat.value}
              </div>
              <div className="text-sm text-zinc-600 mt-1">{stat.label}</div>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border border-zinc-200 bg-white p-8 rounded-md">
          <h3 className="text-xl font-medium tracking-tight text-zinc-900 mb-2">
            Design Your Pass
          </h3>
          <p className="text-sm text-zinc-600 mb-6">
            Create and manage custom Google Wallet passes for your clubs
          </p>
          <Button
            onClick={() => navigate("/designs")}
            className="bg-[var(--brand)] hover:bg-[var(--brand-dark)] text-white"
            data-testid="navigate-designer-btn"
          >
            Manage Designs
          </Button>
        </div>

        <div className="border border-zinc-200 bg-white p-8 rounded-md">
          <h3 className="text-xl font-medium tracking-tight text-zinc-900 mb-2">
            Manage Members
          </h3>
          <p className="text-sm text-zinc-600 mb-6">
            Add members by club and issue passes directly to their email
          </p>
          <Button
            onClick={() => navigate("/members")}
            className="bg-[var(--brand)] hover:bg-[var(--brand-dark)] text-white"
            data-testid="navigate-members-btn"
          >
            Manage Members
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;